// response field description
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import CybsAlert from '@cybs-ui/components/lib/alert';
import CybsCard from '@cybs-ui/components/lib/card';
import CybsTab from '@cybs-ui/components/lib/tab';
import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import '../css/response.css';
import ResponseEditor from "../js/response-editor";
import ResponseHeader from '../js/response-header';
import logo from '../css/Spinner.gif';
import Descriptions from './descriptions';
import {computeHeightOfHeaderForRhs}from './../../../../../commons/header-footer';

var responseCode = "";
var responseTabs = "";
var responseProgressFlag = false;
var responseTree = [];

class ResponseFieldDescription extends React.Component
{
  constructor(props) {
    super(props);
    this.state = { requestResponseDescriptionIndex : 0 };
  }
  responseBodySelectedTab = (e, index) => {
    this.setResponseBodySelectedTab(index);
};
  setResponseBodySelectedTab = (index) => {
    this.setState({requestResponseDescriptionIndex: index});
};

// Helper method to generate response code alert
  generateResponseCodeAlert = (statusCode) => {
    const codeString = String(statusCode).substring(0,1);
    
    if (codeString === "0") {
      return <CybsAlert 
        isInline
        id="responseCodeMessage"
        isDismissable
        i18n={{
          message: "UnExpected Error occured In Processing the Request" 
        }}
        status="negative"
        onDismiss={() => disableCopyMessage("responseCodeMessage")}
      />;
    } else if (codeString === "2") {
      return <CybsAlert 
        isInline
        id="responseCodeMessage"
        isDismissable
        i18n={{
          message: "HTTP Status Code :" + statusCode
        }}
        status="positive"
        onDismiss={() => disableCopyMessage("responseCodeMessage")}
      />;
    } else {
      return <CybsAlert 
        isInline
        id="responseCodeMessage"
        isDismissable
        i18n={{
          message: "HTTP Status Code :" + statusCode
        }}
        status="negative"
        onDismiss={() => disableCopyMessage("responseCodeMessage")}
      />;
    }
  };

  // Helper method to generate descriptions tab
  generateDescriptionsTab = (responseTree) => ({
    label: 'Descriptions',
    children: (
      <div style={{ marginTop: '-20px', height:'350px'}}>
        <div className="response-field-descriptions" style={{height:'100%',overflowY:'auto'}}>
          <Descriptions
            jsTree={responseTree}
            display="block" 
            parent="root"
            type="response"
          />
        </div>
      </div>
    )
  });

  // Helper method to generate body tab
  generateBodyTab = (responseCode, responseProgressFlag) => {
    if (responseProgressFlag) {
      return {
        label: 'Body',
        children: (
          <div id="responseBody">
            <img id="progressInResponse" color="secondary" src={logo} alt="loading..."/>
          </div>
        )
      };
    } else {
      return {
        label: 'Body',
        children: (
          <div id="responseBody">
            <div id="responseCodeMessage">{responseCode}</div>         
            <div id='response-editor-body' style={{display:'flex'}}>
              <div id="response-code-status"></div>
              <ResponseEditor/>
            </div>
          </div>
        )
      };
    }
  };

  // Helper method to generate headers tab
  generateHeadersTab = () => ({
    label: 'Headers',
    children: (
      <div id="responseHeaders">
        <ResponseHeader/>
      </div>
    )
  });

  render(){

    const responseProgressFlag = this.props.responseProgressFlag || false;
    const responseTree = this.props.responseTree || [];
    
    computeHeightOfHeaderForRhs();
    
    let responseCode = "";
    let responseTabs = [];
    
    if(this.props.responseContent != undefined || this.props.isResponseActivated == true){
        responseCode = this.generateResponseCodeAlert(this.props.responseCode);
        enableCopyMessage('responseCodeMessage');

        if(this.props.responseHeaders != undefined){
          if(responseProgressFlag){
            responseTabs = [
              this.generateBodyTab(responseCode, responseProgressFlag),
              this.generateDescriptionsTab(responseTree)
            ]; 
          }
          else{
            responseTabs = [
              this.generateBodyTab(responseCode, responseProgressFlag),
              this.generateHeadersTab(),
              this.generateDescriptionsTab(responseTree)
            ];
          }
        }
        else if(this.props.responseCode != undefined){
          if(responseProgressFlag){
            responseTabs = [
              this.generateBodyTab(responseCode, responseProgressFlag),
              this.generateDescriptionsTab(responseTree)
            ]; 
          }
          else{
            responseTabs = [
              this.generateBodyTab(responseCode, responseProgressFlag),
              this.generateDescriptionsTab(responseTree)
            ];
          } 
        }
        else{
          if(responseProgressFlag){
            responseTabs = [
              this.generateBodyTab(responseCode, responseProgressFlag),
              this.generateDescriptionsTab(responseTree)
            ];  
          }
          else{
            responseTabs = [
              {
                label: 'Body',
                children: (
                  <div id="responseBody">
                    <div id='response-editor-body' style={{display:'flex'}}>
                      <ResponseEditor/>
                    </div>
                  </div>
                )
              },
              this.generateDescriptionsTab(responseTree)
            ];  
          }
        }
    }
    else {
      if(responseProgressFlag){
        responseTabs = [
          this.generateBodyTab(responseCode, responseProgressFlag),
          this.generateDescriptionsTab(responseTree)
        ]; 
      } else {
        responseTabs = [
          this.generateDescriptionsTab(responseTree)
        ]; 
      }
    }
      if(this.state.requestResponseDescriptionIndex >= responseTabs.length){
        this.setState({requestResponseDescriptionIndex: 0})
      }
      
      $(".summarySection a").attr("target","_blank");
      $('.prerequisitesSection a').attr("target", "_self");
      $("#descriptionsTab a").attr("target","_blank");
      $(".request-field-descriptions a").attr("target","_blank");
      $(".response-field-descriptions a").attr("target","_blank");
      $("#react-aria-modal-dialog a").attr("target","_blank");
    return(
      <div style={{ marginBottom: '30px',marginLeft:'20px',marginRight:'20px'}}>
        <CybsCard
          label = "Response"
           header ={
            <CybsActionBar
            dataTest="payment-info-with-collapsible"
            i18n={{ title: "Response" }}
          />
        }
        
          bodyMaxHeight={100}
          dataTest="Response Field Description"
        >
         <div>
                
                
                <div id = "request-tabs" style={{width:'100%'}}>
                    <CybsTab
                    headingLevel={3}
                    selectedTab={this.state.requestResponseDescriptionIndex}
                    onSelectTab={(e, index) => this.responseBodySelectedTab(e, index)}
                    dataTest="heading-level-tabs-request-builder"
                    tag="button"
                    // isUnderlined
                    tabs={responseTabs}
                    />
                </div>   
            </div> 
         
        </CybsCard>
        
      </div>
    )     
  }
}


function enableCopyMessage(id)
{
    var element = document.getElementById(id);
    if(element != null)
    {
        element.style.display = "block";
    }
}


function disableCopyMessage(id)
{
    var element = document.getElementById(id);
    if(element != null)
    {
        element.style.display = "none";
    }
}
function mapStateToProps(state){
  return{
        responseTree: state.rhsReducer.responseTree,
        responseCode:state.rhsReducer.responseCode,
        responseContent:state.rhsReducer.responseContent,
        responseHeaders:state.rhsReducer.responseHeaders,
        isResponseActivated: state.rhsReducer.isResponseActivated,
        responseProgressFlag: state.rhsReducer.responseProgressFlag
      }
}

export default connect(mapStateToProps)(ResponseFieldDescription);
